<div class="grid lg:grid-cols-2 w-full h-full min-h-screen">
  <!-- Brand Section (Visuals) -->
  <div class="lg:rounded-xl lg:border lg:border-gray-200 dark:lg:border-gray-800 lg:m-5 relative overflow-hidden flex flex-col items-stretch lg:order-2">
    <!-- Light Mode Image -->
    <img class="absolute inset-0 w-full h-full object-cover object-top xxl:object-center dark:hidden" src="/assets/media/images/veraxum_auth_background_light.jpg" alt="Light Background" />
    <!-- Dark Mode Image -->
    <img class="absolute inset-0 w-full h-full object-cover object-top xxl:object-center hidden dark:block z-0" src="/assets/media/images/veraxum_auth_background_dark.jpg" alt="Dark Background" />
    
    <div class="relative z-10 flex flex-col p-8 lg:p-16 gap-4 h-full">
      <div class="flex flex-col gap-3 bg-gradient-to-br from-white/50 to-white/10 dark:from-gray-800/80 dark:to-black/30 backdrop-blur-[2px] rounded-3xl p-8 border border-white/60 dark:border-white/10 shadow-2xl max-w-md w-fit">
        <a routerLink="/">
          <img class="h-[28px] max-w-none rounded-full" [src]="themeService.effectiveTheme() === 'dark' ? '/assets/media/app/logo_dark.png' : '/assets/media/app/logo.png'" alt="logo"/>
        </a>
        <h3 class="text-2xl font-semibold text-mono">
          Veraxum Access Portal
        </h3>
        <div class="text-[17px] font-medium text-secondary-foreground leading-relaxed">
          Explainable AI Platform
          <br/>
          secure
          <span class="text-mono font-semibold text-primary">
            efficient user access
          </span>
          to the Veraxum
          <br/>
          Dashboard interface.
        </div>
      </div>
    </div>
  </div>

  <!-- Form Section -->
  <div class="flex justify-center items-center p-8 lg:p-10 w-full relative lg:order-1">
    <router-outlet></router-outlet>
  </div>
</div>
